import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { FilterLogicSelect } from "~/components/Filters/FilterLogicSelect";
export const SmartTagsFilter = /*#__PURE__*/ memo((param)=>{
    let { SmartTagsSelect, onLogicChange, onSelectedSmartTagsChanged, selectedSmartTags, selectedLogic } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col items-start",
        children: [
            /*#__PURE__*/ _jsx(SmartTagsSelect, {
                className: "order-2 w-full",
                selectedSmartTags: selectedSmartTags,
                onSelectedSmartTagsChanged: onSelectedSmartTagsChanged
            }),
            /*#__PURE__*/ _jsx(FilterLogicSelect, {
                className: "order-1",
                selectedLogic: selectedLogic,
                onLogicChange: onLogicChange
            })
        ]
    });
});
SmartTagsFilter.displayName = "SmartTagsFilter";
